import type { ReactNode } from "react";
import { useCallback, useRef, useState } from "react";
import { withResolvers } from "./withResolvers";

export function useAsyncDialog<T, Arg = object>(
  Dialog: (props: { onAccept(v: T | undefined): void; onCancel(): void; arg?: Arg }) => ReactNode,
) {
  const [state, setState] = useState<{
    open: boolean;
    arg?: Arg;
  }>({
    open: false,
  });
  const promiseRef = useRef(withResolvers<T | undefined>());

  const onAccept = useCallback((v: T) => {
    setState({ open: false });
    promiseRef.current.resolve(v);
    promiseRef.current = withResolvers();
  }, []);

  const onCancel = useCallback(() => {
    setState({ open: false });
    promiseRef.current.resolve(undefined);
    promiseRef.current = withResolvers();
  }, []);

  return {
    async open(arg?: Arg) {
      setState({ open: true, arg });
      return promiseRef.current.promise;
    },
    portal: state.open ? <Dialog onCancel={onCancel} onAccept={onAccept} arg={state.arg} /> : null,
  };
}
